import { addCircleIcon } from '../../icons/add-circle';
import { addSquareIcon } from '../../icons/add-square';
import { aggregatorIcon } from '../../icons/aggregator';
import { allInvoiceIcon } from '../../icons/all-invoice';
import { arrowCircleLeftIcon } from '../../icons/arrow-circle-left';
import { arrowDownIcon } from '../../icons/arrow-down';
import { arrowRightIcon } from '../../icons/arrow-right';
import { arrowSideLeftIcon } from '../../icons/arrow-side-left';
import { arrowSideRightIcon } from '../../icons/arrow-side-right';
import { arrowUpIcon } from '../../icons/arrow-up';
import { attachSquareIcon } from '../../icons/attach-square';
import { backIcon } from '../../icons/back';
import { balanceIcon } from '../../icons/balance';
import { bgWalletIcon } from '../../icons/bg-wallet';
import { boldAllIcon } from '../../icons/bold-all';
import { boldArrowDownIcon } from '../../icons/bold-arrow-down';
import { boldArrowLeftIcon } from '../../icons/bold-arrow-left';
import { boldArrowRightIcon } from '../../icons/bold-arrow-right';
import { boldArrowUpIcon } from '../../icons/bold-arrow-up';
import { boldBoxIcon } from '../../icons/bold-box';
import { boldClipboardTickIcon } from '../../icons/bold-clipboard-tick';
import { boldDocumentIcon } from '../../icons/bold-document';
import { boldDownloadSquareIcon } from '../../icons/bold-download-square';
import { boldDropIcon } from '../../icons/bold-drop';
import { boldEditIcon } from '../../icons/bold-edit';
import { boldExportIcon } from '../../icons/bold-export';
import { boldFlagIcon } from '../../icons/bold-flag';
import { boldInfoCircleIcon } from '../../icons/bold-info-circle';
import { boldLocationIcon } from '../../icons/bold-location';
import { boldLoginIcon } from '../../icons/bold-login';
import { boldMessageQuestionIcon } from '../../icons/bold-message-question';
import { boldMinusCircleIcon } from '../../icons/bold-minus-circle';
import { boldMinusIcon } from '../../icons/bold-minus';
import { boldMobileIcon } from '../../icons/bold-mobile';
import { boldMonitorIcon } from '../../icons/bold-monitor';
import { boldSearchIcon } from '../../icons/bold-search';
import { boldTemperatureIcon } from '../../icons/bold-temperature';
import { boldTimerIcon } from '../../icons/bold-timer';
import { boldUserGroupOutlineIcon } from '../../icons/bold-user-group-outline';
import { boldUserIcon } from '../../icons/bold-user';
import { boldWarehouseIcon } from '../../icons/bold-warehouse';
import { boldWarningIcon } from '../../icons/bold-warning';
import { boldWeightIcon } from '../../icons/bold-weight';
import { boxAddIcon } from '../../icons/box-add';
import { boxIconIcon } from '../../icons/box-icon';
import { brakeIcon } from '../../icons/brake';
import { buildingGroupIcon } from '../../icons/building-group';
import { bulkBoxIcon } from '../../icons/bulk-box';
import { bulkChartSquareIcon } from '../../icons/bulk-chart-square';
import { bulkRoutingIcon } from '../../icons/bulk-routing';
import { burgerIcon } from '../../icons/burger';
import { calendarIcon } from '../../icons/calendar';
import { cementTruckIcon } from '../../icons/cement-truck';
import { chartIcon } from '../../icons/chart';
import { clipboardTickIcon } from '../../icons/clipboard-tick';
import { closeCircleIcon } from '../../icons/close-circle';
import { closeSquareIcon } from '../../icons/close-square';
import { contactIcon } from '../../icons/contact';
import { correctIcon } from '../../icons/correct';
import { crownIcon } from '../../icons/crown';
import { customersIcon } from '../../icons/customers';
import { detailsIcon } from '../../icons/details';
import { disabledDriverIcon } from '../../icons/disabled-driver';
import { disabledTruckIcon } from '../../icons/disabled-truck';
import { distanceIcon } from '../../icons/distance';
import { documentUploadIcon } from '../../icons/document-upload';
import { drivingIcon } from '../../icons/driving';
import { editIcon } from '../../icons/edit';
import { engineActiveIcon } from '../../icons/engine-active';
import { engineIdleIcon } from '../../icons/engine-idle';
import { exclamationMarkIcon } from '../../icons/exclamation-mark';
import { flagIcon } from '../../icons/flag';
import { fleetIcon } from '../../icons/fleet';
import { fromIcon } from '../../icons/from';
import { globalIcon } from '../../icons/global';
import { gpsIcon } from '../../icons/gps';
import { groupIcon } from '../../icons/group';
import { headphoneIcon } from '../../icons/headphone';
import { homeIcon } from '../../icons/home';
import { inProgressIcon } from '../../icons/in-progress';
import { informationIcon } from '../../icons/information';
import { invoicesIcon } from '../../icons/invoices';
import { likeTagIcon } from '../../icons/like-tag';
import { linkIcon } from '../../icons/link';
import { liveTrackingIcon } from '../../icons/live-tracking';
import { locationIcon } from '../../icons/location';
import { logoutIcon } from '../../icons/logout';
import { logsIcon } from '../../icons/logs';
import { madarBrandingIconIcon } from '../../icons/madar-branding-icon';
import { madarProvidersIcon } from '../../icons/madar-providers';
import { manageIcon } from '../../icons/manage';
import { mapIcon } from '../../icons/map';
import { markerIcon } from '../../icons/marker';
import { maskGroupIcon } from '../../icons/mask-group';
import { messageQuestionIcon } from '../../icons/message-question';
import { moneyIcon } from '../../icons/money';
import { notFoundIcon } from '../../icons/not-found';
import { notificationIcon } from '../../icons/notification';
import { offerIcon } from '../../icons/offer';
import { outlineAddSquareIcon } from '../../icons/outline-add-square';
import { outlineArrowRightIcon } from '../../icons/outline-arrow-right';
import { outlineBarcodeIcon } from '../../icons/outline-barcode';
import { outlineDocumentIcon } from '../../icons/outline-document';
import { outlineEditIcon } from '../../icons/outline-edit';
import { outlineEyeIcon } from '../../icons/outline-eye';
import { outlineScanIcon } from '../../icons/outline-scan';
import { outlineTimerIcon } from '../../icons/outline-timer';
import { outlineWalletIcon } from '../../icons/outline-wallet';
import { outlineWarningIcon } from '../../icons/outline-warning';
import { overDueIcon } from '../../icons/over-due';
import { packageIcon } from '../../icons/package';
import { paidStatusIcon } from '../../icons/paid-status';
import { personIcon } from '../../icons/person';
import { popoverArrowDownIcon } from '../../icons/popover-arrow-down';
import { receiverLocationIcon } from '../../icons/receiver-location';
import { regionLocationIcon } from '../../icons/region-location';
import { reportsIcon } from '../../icons/reports';
import { rightArrowIcon } from '../../icons/right-arrow';
import { rightIcon } from '../../icons/right';
import { routeIcon } from '../../icons/route';
import { routingIcon } from '../../icons/routing';
import { searchAltIcon } from '../../icons/search-alt';
import { searchLoactionIcon } from '../../icons/search-loaction';
import { searchIcon } from '../../icons/search';
import { settingsIcon } from '../../icons/settings';
import { shipmentsIcon } from '../../icons/shipments';
import { smallPersonIcon } from '../../icons/small-person';
import { sortArrowIcon } from '../../icons/sort-arrow';
import { speedIcon } from '../../icons/speed';
import { stopIcon } from '../../icons/stop';
import { temperatureIcon } from '../../icons/temperature';
import { tickSquareIcon } from '../../icons/tick-square';
import { timerIcon } from '../../icons/timer';
import { toIcon } from '../../icons/to';
import { tooltipIcon } from '../../icons/tooltip';
import { transparentLocationIcon } from '../../icons/transparent-location';
import { transparentMoneyIcon } from '../../icons/transparent-money';
import { transportationPaymentsIcon } from '../../icons/transportation-payments';
import { trashIcon } from '../../icons/trash';
import { tripPlanningIcon } from '../../icons/trip-planning';
import { truckImagePlaceholderIcon } from '../../icons/truck-image-placeholder';
import { truckTickIcon } from '../../icons/truck-tick';
import { truckTimeIcon } from '../../icons/truck-time';
import { truckIcon } from '../../icons/truck';
import { underReviewIcon } from '../../icons/under-review';
import { vectorIcon } from '../../icons/vector';
import { warehouseIcon } from '../../icons/warehouse';
import { warningIcon } from '../../icons/warning';
import { weightIcon } from '../../icons/weight';
import { wrongIcon } from '../../icons/wrong';
import { trapezoidEdgeIcon } from 'src/app/icons/trapezoid-edge';
import { bulkTicketIcon } from 'src/app/icons/bulk-ticket';
import { boldEyeIcon } from 'src/app/icons/bold-eye';
import { tickCircleIcon } from 'src/app/icons/tick-circle';
import { boldDriverIcon } from 'src/app/icons/bold-driver';
import { accentBoxIcon } from 'src/app/icons/accent-box';
import { boldLinkIcon } from 'src/app/icons/bold-link';
import { boldRefreshIcon } from 'src/app/icons/bold-refresh';
import { outlineTrashIcon } from 'src/app/icons/outline-trash';
import { boldDownloadMinimalisticIcon } from 'src/app/icons/bold-download-minimalistic';
import { infoBardIcon } from 'src/app/icons/info-bard';
import { linearMenuIcon } from '../../icons/linear-menu';
import { mobileIcon } from 'src/app/icons/mobile';
import { avlIcon } from 'src/app/icons/avl';
import { boldTruckIcon } from 'src/app/icons/bold-truck';
import { bulkSearchIcon } from 'src/app/icons/bulk-search';
import { boldArrowCircleLeftIcon } from 'src/app/icons/bold-arrow-circle-left';
import { boldUserCircleIcon } from 'src/app/icons/bold-user-circle';
import { boldTimelineIcon } from 'src/app/icons/bold-timeline';
import { driverIcon } from 'src/app/icons/driver';
import { boldDocumentTextIcon } from 'src/app/icons/bold-document-text';
import { boxIcon } from 'src/app/icons/box';
import { dottedIcon } from 'src/app/icons/dotted';
import { outlineCloseCircleIcon } from 'src/app/icons/outline-close-circle';
import { rotateRightIcon } from 'src/app/icons/rotate-right';
import { boldOverspeedIcon } from 'src/app/icons/bold-overspeed';
import { boldForwardArrowIcon } from 'src/app/icons/bold-forward-arrow';
import { mapMarkerActiveIconIcon } from 'src/app/icons/map-marker-active-icon';
import { mapMarkerIconIcon } from 'src/app/icons/map-marker-icon';
import { rightTickCircleIcon } from 'src/app/icons/right-tick-circle';
import { starIcon } from 'src/app/icons/star';
import { outlineMessageIcon } from 'src/app/icons/outline-message';
import { menuVertIcon } from 'src/app/icons/menu-vert';
import { warningAccentIcon } from 'src/app/icons/warning-accent';
import { saudiRiyalIcon } from 'src/app/icons/saudi_riyal';
import { buildIcon } from 'src/app/icons/build';
import { outlineCloudIcon } from 'src/app/icons/outline-cloud';
import { outlineLiveTrackingIcon } from 'src/app/icons/outline-live-tracking';
import { userIcon } from 'src/app/icons/user';
import { outlineRoutingIcon } from 'src/app/icons/outline-routing';
import { saudiFlagIcon } from 'src/app/icons/saudi-flag';
import { bulkReceiptItemIcon } from 'src/app/icons/bulk-receipt-item';
import { envelopIcon } from 'src/app/icons/envelop';
import { callingIcon } from 'src/app/icons/calling';
import { swapIcon } from 'src/app/icons/swap';
import { arrowNoBoxDownIcon } from 'src/app/icons/arrow-no-box-down';
import { arrowNoBoxUpIcon } from 'src/app/icons/arrow-no-box-up';
import { fromToLocationIcon } from 'src/app/icons/from-to-location';
import { spotlightMarkerIcon } from 'src/app/icons/spotlight-marker';
import { boldReplyArrowIcon } from 'src/app/icons/bold-reply-arrow';
import { outlineTruckIcon } from 'src/app/icons/outline-truck';
import { outlineMinusIcon } from 'src/app/icons/outline-minus';
import { outlineAddIcon } from 'src/app/icons/outline-add';
import { twotoneEmptyWalletIcon } from 'src/app/icons/twotone-empty-wallet';
import { twotoneBoxIcon } from 'src/app/icons/twotone-box';
import { twotoneFlashIcon } from 'src/app/icons/twotone-flash';
import { twotoneStatusUpIcon } from 'src/app/icons/twotone-status-up';
import { twotoneTruckIcon } from 'src/app/icons/twotone-truck';
import { outlineRankingIcon } from 'src/app/icons/outline-ranking';
import { downArrowBoldIcon } from 'src/app/icons/down-arrow-bold';
import { outlineCopyIcon } from 'src/app/icons/outline-copy';
import { crossIcon } from 'src/app/icons/cross';
import { boldHouseIcon } from 'src/app/icons/bold-house';
import { outlineLocationIcon } from 'src/app/icons/outline-location';
import { boldDocumentAltIcon } from 'src/app/icons/bold-document-alt';
import { outlineClockIcon } from 'src/app/icons/outline-clock';
import { outlineTickCircleIcon } from 'src/app/icons/outline-tick-circle';
import { informationTabIcon } from 'src/app/icons/information-tab';
import { pageIcon } from 'src/app/icons/page';
import { rightCircleIcon } from 'src/app/icons/right-circle';
import { roleIcon } from 'src/app/icons/role';
import { madarLogoIcon } from 'src/app/icons/madar-logo';
import { androidIcon } from 'src/app/icons/android';
import { appleIcon } from 'src/app/icons/apple';
import { appleStoreIcon } from 'src/app/icons/apple-store';
import { googleStoreIcon } from 'src/app/icons/google-store';
import { againIcon } from 'src/app/icons/again';
import { outlineDangerIcon } from 'src/app/icons/outline-danger';
import { outlineAlarmIcon } from 'src/app/icons/outline-alarm';
import { outlineWarnIcon } from 'src/app/icons/outline-warn';
import { outlineTickIcon } from 'src/app/icons/outline-tick';
import { boldConfettiIcon } from 'src/app/icons/bold-confetti';
import { boldJudgeIcon } from 'src/app/icons/bold-judge';
import { boldDangerIcon } from 'src/app/icons/bold-danger';
import { boldTaskIcon } from 'src/app/icons/bold-task';
import { outlineClockAlarmIcon } from 'src/app/icons/outline-clock-alarm';
import { outlineFileCheckIcon } from 'src/app/icons/outline-file-check';
import { outlineSmsIcon } from 'src/app/icons/outline-sms';
import { boldCallIcon } from 'src/app/icons/bold-call';
import { outlineLockIcon } from 'src/app/icons/outline-lock';
import { outlineEditNewIcon } from 'src/app/icons/outline-edit-new';
import { outlinePageIcon } from 'src/app/icons/outline-page';
import { outlineTaskIcon } from 'src/app/icons/outline-task';
import { outlineCalendarIcon } from 'src/app/icons/outline-calendar';
import { outlineCallIcon } from 'src/app/icons/outline-call';
import { boldDoubleArrowDownIcon } from 'src/app/icons/bold-double-arrow-down';
import { mapPointIcon } from 'src/app/icons/map-point';
import { outline3DcubeIcon } from 'src/app/icons/outline-3dcube';
import { outlineMenuBoardIcon } from 'src/app/icons/outline-menu-board';
import { outlineMoneysIcon } from 'src/app/icons/outline-moneys';
import { outlineNoteIcon } from 'src/app/icons/outline-note';
import { outlineShareIcon } from 'src/app/icons/outline-share';
import { outlineStickynoteIcon } from 'src/app/icons/outline-stickynote';
import { outlineUserIcon } from 'src/app/icons/outline-user';
import { outlineWeightIcon } from 'src/app/icons/outline-weight';
import { outlineArrowDownIcon } from 'src/app/icons/outline-arrow-down';
import { boldShareIcon } from 'src/app/icons/bold-Share';
import { outlineJudgeIcon } from 'src/app/icons/outline-judge';
import { twotoneJudgeIcon } from 'src/app/icons/twotone-judge';
import { outlineShieldTickIcon } from 'src/app/icons/outline-shield-tick';
import { outlineCheckIcon } from 'src/app/icons/outline-check';
import { statusCreatedIcon } from 'src/app/icons/status-created';
import { statusDeliveredIcon } from 'src/app/icons/status-delivered';
import { statusDriverIcon } from 'src/app/icons/status-driver';
import { statusLoadedIcon } from 'src/app/icons/status-loaded';
import { statusLocationIcon } from 'src/app/icons/status-location';
import { statusStartedIcon } from 'src/app/icons/status-started';
import { statusTimelineIcon } from 'src/app/icons/status-timeline';
import { statusTruckIcon } from 'src/app/icons/status-truck';
import { docDocumentIcon } from 'src/app/icons/doc-document';
import { docDownloadIcon } from 'src/app/icons/doc-download';
import { docEyeIcon } from 'src/app/icons/doc-eye';
import { docCheckIcon } from 'src/app/icons/doc-check';
import { docShieldIcon } from 'src/app/icons/doc-shield';
import { boldVehicleIcon } from 'src/app/icons/bold-vehicle';
import { tagUserIcon } from 'src/app/icons/tag-user';
import { outlineReceiptIcon } from 'src/app/icons/outline-receipt';
import { boldBuildingsIcon } from 'src/app/icons/bold-buildings';
import { outlinePresentionChartIcon } from 'src/app/icons/outline-presention-chart';
import { outlineFileIcon } from 'src/app/icons/outline-file';
import { arrowOutlineDownIcon } from 'src/app/icons/arrow-outline-down';
import { arrowOutlineUpIcon } from 'src/app/icons/arrow-outline-up';
import { doubleArrowIcon } from 'src/app/icons/double-arrow';
import { boldCancelIcon } from 'src/app/icons/bold-cancel';
import { outlineBoxIcon } from 'src/app/icons/outline-box';
import { arrowLeftIcon } from 'src/app/icons/arrow-left';
import { arrowLeftDoubleFillIcon } from 'src/app/icons/arrow-left-double-fill';
import { outlineNotificationIcon } from 'src/app/icons/outline-notification';
import { outlineHomeIcon } from 'src/app/icons/outline-home';
import { receiptItemIcon } from 'src/app/icons/receipt-item';
import { outlineProfileTwoUsersIcon } from 'src/app/icons/Outline-profile-two-users';
import { boldDiagramIcon } from 'src/app/icons/bold-diagram';
import { outlineSettingIcon } from 'src/app/icons/outline-setting';
import { outlineArrowUpIcon } from 'src/app/icons/outline-arrow-up';
import { outlineFilterIcon } from 'src/app/icons/outline-filter';
import { outlineCrossIcon } from 'src/app/icons/outline-cross';
import { icoGripIcon } from 'src/app/icons/icoGrip';
import { outlineProfileAddIcon } from 'src/app/icons/outline-profile-add';
import { boldUploadMinimalisticIcon } from 'src/app/icons/bold-Upload-Minimalistic';
import { outlineMinReceiptIcon } from 'src/app/icons/outline-min-receipt';
import { twotoneDiagramIcon } from 'src/app/icons/twotone-diagram';
import { twotoneWalletEmptyIcon } from 'src/app/icons/twotone-wallet-empty';
import { outlineMessagesIcon } from 'src/app/icons/outline-messages';
import { twotoneMessagesIcon } from 'src/app/icons/twotone-messages';
import { outlineSendIcon } from 'src/app/icons/outline-send';
import { outlineArrowNarrowRightIcon } from 'src/app/icons/outline-arrow-narrow-right';
import { twotoneMessageTextIcon } from 'src/app/icons/twotone-message-text';
import { outlineMessageTextIcon } from 'src/app/icons/outline-message-text';
import { outlineForbiddenIcon } from 'src/app/icons/outline-forbidden';
import { twotoneNotificationBingIcon } from 'src/app/icons/twotone-notification-bing';
import { outlineCardIcon } from 'src/app/icons/outline-card';
import { twotoneLocationIcon } from 'src/app/icons/twotone-location';
import { twoBoxIcon } from 'src/app/icons/two-box';
import { outlineFileTextIcon } from 'src/app/icons/outline-file-text';
import { outlineDriverIcon } from 'src/app/icons/outline-driver';

export const ICONS = [
  addCircleIcon,
  addSquareIcon,
  aggregatorIcon,
  allInvoiceIcon,
  arrowCircleLeftIcon,
  arrowDownIcon,
  arrowRightIcon,
  arrowSideLeftIcon,
  arrowSideRightIcon,
  arrowUpIcon,
  attachSquareIcon,
  backIcon,
  balanceIcon,
  bgWalletIcon,
  boldAllIcon,
  boldArrowDownIcon,
  boldArrowLeftIcon,
  boldArrowRightIcon,
  boldArrowUpIcon,
  boldBoxIcon,
  boldClipboardTickIcon,
  boldDocumentIcon,
  boldDownloadSquareIcon,
  boldDropIcon,
  boldEditIcon,
  boldExportIcon,
  boldFlagIcon,
  boldInfoCircleIcon,
  boldLocationIcon,
  boldLoginIcon,
  boldMessageQuestionIcon,
  boldMinusCircleIcon,
  boldMinusIcon,
  boldMobileIcon,
  boldMonitorIcon,
  boldSearchIcon,
  boldTemperatureIcon,
  boldTimerIcon,
  boldUserGroupOutlineIcon,
  boldUserIcon,
  trapezoidEdgeIcon,
  boldWarehouseIcon,
  boldWarningIcon,
  boldWeightIcon,
  boxAddIcon,
  boxIconIcon,
  brakeIcon,
  buildingGroupIcon,
  bulkBoxIcon,
  bulkChartSquareIcon,
  bulkRoutingIcon,
  bulkTicketIcon,
  burgerIcon,
  calendarIcon,
  cementTruckIcon,
  chartIcon,
  clipboardTickIcon,
  closeCircleIcon,
  closeSquareIcon,
  contactIcon,
  correctIcon,
  crownIcon,
  customersIcon,
  detailsIcon,
  disabledDriverIcon,
  disabledTruckIcon,
  distanceIcon,
  documentUploadIcon,
  drivingIcon,
  editIcon,
  engineActiveIcon,
  engineIdleIcon,
  exclamationMarkIcon,
  flagIcon,
  fleetIcon,
  fromIcon,
  globalIcon,
  gpsIcon,
  groupIcon,
  headphoneIcon,
  homeIcon,
  inProgressIcon,
  informationIcon,
  invoicesIcon,
  likeTagIcon,
  linkIcon,
  liveTrackingIcon,
  locationIcon,
  logoutIcon,
  logsIcon,
  madarBrandingIconIcon,
  madarProvidersIcon,
  manageIcon,
  mapIcon,
  markerIcon,
  maskGroupIcon,
  messageQuestionIcon,
  moneyIcon,
  notFoundIcon,
  notificationIcon,
  offerIcon,
  outlineAddSquareIcon,
  outlineArrowRightIcon,
  outlineBarcodeIcon,
  outlineDocumentIcon,
  outlineEditIcon,
  outlineEyeIcon,
  outlineScanIcon,
  outlineTimerIcon,
  outlineWalletIcon,
  outlineWarningIcon,
  overDueIcon,
  packageIcon,
  paidStatusIcon,
  personIcon,
  popoverArrowDownIcon,
  receiverLocationIcon,
  regionLocationIcon,
  reportsIcon,
  rightArrowIcon,
  rightIcon,
  routeIcon,
  routingIcon,
  searchAltIcon,
  searchLoactionIcon,
  searchIcon,
  settingsIcon,
  shipmentsIcon,
  smallPersonIcon,
  sortArrowIcon,
  speedIcon,
  stopIcon,
  temperatureIcon,
  tickSquareIcon,
  timerIcon,
  toIcon,
  tooltipIcon,
  transparentLocationIcon,
  transparentMoneyIcon,
  transportationPaymentsIcon,
  trashIcon,
  tripPlanningIcon,
  truckImagePlaceholderIcon,
  truckTickIcon,
  truckTimeIcon,
  truckIcon,
  underReviewIcon,
  vectorIcon,
  warehouseIcon,
  warningIcon,
  weightIcon,
  wrongIcon,
  boldEyeIcon,
  tickCircleIcon,
  boldDriverIcon,
  accentBoxIcon,
  boldLinkIcon,
  boldRefreshIcon,
  outlineTrashIcon,
  boldDownloadMinimalisticIcon,
  infoBardIcon,
  linearMenuIcon,
  mobileIcon,
  avlIcon,
  drivingIcon,
  boldTruckIcon,
  bulkSearchIcon,
  boldArrowCircleLeftIcon,
  boldUserCircleIcon,
  boldTimelineIcon,
  driverIcon,
  boldDocumentTextIcon,
  boxIcon,
  dottedIcon,
  outlineCloseCircleIcon,
  rotateRightIcon,
  outlineArrowRightIcon,
  boldOverspeedIcon,
  boldForwardArrowIcon,
  mapMarkerActiveIconIcon,
  mapMarkerIconIcon,
  rightTickCircleIcon,
  starIcon,
  outlineMessageIcon,
  menuVertIcon,
  mapMarkerActiveIconIcon,
  mapMarkerIconIcon,
  rightTickCircleIcon,
  warningAccentIcon,
  saudiRiyalIcon,
  bulkReceiptItemIcon,
  buildIcon,
  outlineCloudIcon,
  outlineLiveTrackingIcon,
  userIcon,
  outlineRoutingIcon,
  saudiFlagIcon,
  envelopIcon,
  callingIcon,
  swapIcon,
  arrowNoBoxUpIcon,
  arrowNoBoxDownIcon,
  fromToLocationIcon,
  spotlightMarkerIcon,
  boldReplyArrowIcon,
  outlineTruckIcon,
  outlineMinusIcon,
  outlineAddIcon,
  outlineRankingIcon,
  twotoneBoxIcon,
  twotoneEmptyWalletIcon,
  twotoneFlashIcon,
  twotoneStatusUpIcon,
  twotoneTruckIcon,
  downArrowBoldIcon,
  outlineCopyIcon,
  crossIcon,
  boldHouseIcon,
  outlineLocationIcon,
  boldDocumentAltIcon,
  outlineClockIcon,
  outlineTickCircleIcon,
  informationTabIcon,
  pageIcon,
  rightCircleIcon,
  roleIcon,
  madarLogoIcon,
  appleIcon,
  androidIcon,
  appleStoreIcon,
  googleStoreIcon,
  againIcon,
  outlineDangerIcon,
  outlineAlarmIcon,
  outlineWarnIcon,
  outlineTickIcon,
  boldConfettiIcon,
  boldJudgeIcon,
  boldDangerIcon,
  boldTaskIcon,
  outlineClockAlarmIcon,
  outlineFileCheckIcon,
  outlineSmsIcon,
  boldCallIcon,
  outlineLockIcon,
  arrowLeftIcon,
  boldDoubleArrowDownIcon,
  mapPointIcon,
  outlineCalendarIcon,
  outlineCallIcon,
  outline3DcubeIcon,
  outlineBoxIcon,
  outlineDocumentIcon,
  outlineMenuBoardIcon,
  outlineMoneysIcon,
  outlineShareIcon,
  outlineStickynoteIcon,
  outlineUserIcon,
  outlineWeightIcon,
  outlineArrowDownIcon,
  outlineEditNewIcon,
  outlinePageIcon,
  outlineNoteIcon,
  outlineTaskIcon,
  arrowLeftDoubleFillIcon,
  outlineNotificationIcon,
  outlineHomeIcon,
  receiptItemIcon,
  outlineProfileTwoUsersIcon,
  boldDiagramIcon,
  outlineSettingIcon,
  outlineArrowUpIcon,
  boldShareIcon,
  outlineJudgeIcon,
  twotoneJudgeIcon,
  statusCreatedIcon,
  statusDeliveredIcon,
  statusDriverIcon,
  statusLoadedIcon,
  statusLocationIcon,
  statusStartedIcon,
  statusTimelineIcon,
  statusTruckIcon,
  docDocumentIcon,
  docDownloadIcon,
  docEyeIcon,
  docCheckIcon,
  docShieldIcon,
  boldVehicleIcon,
  tagUserIcon,
  outlineReceiptIcon,
  boldBuildingsIcon,
  outlineShieldTickIcon,
  outlineCheckIcon,
  outlinePresentionChartIcon,
  outlineFileIcon,
  arrowOutlineDownIcon,
  arrowOutlineUpIcon,
  doubleArrowIcon,
  boldCancelIcon,
  outlineFilterIcon,
  outlineCrossIcon,
  icoGripIcon,
  outlineProfileAddIcon,
  boldUploadMinimalisticIcon,
  outlineMinReceiptIcon,
  twotoneNotificationBingIcon,
  outlineCardIcon,
  outlineMessagesIcon,
  twotoneMessagesIcon,
  outlineSendIcon,
  twotoneDiagramIcon,
  twotoneWalletEmptyIcon,
  outlineMessageTextIcon,
  twotoneMessageTextIcon,
  outlineArrowNarrowRightIcon,
  outlineForbiddenIcon,
  twotoneLocationIcon,
  twoBoxIcon,
  outlineFileTextIcon,
  outlineDriverIcon
];
